import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const dataIngestionAdminAccessControl: DomainAccessControlConfig = {}
